import React from 'react';
import { TackNotificationSelectionOptionsShape } from '../shapes';
import Waiting from './waiting';
import GoTo from './go_to';

export default class TackNotifictionSelectionOptions extends React.Component {
  static propTypes = {
    tackNotificationSelectionOptions: TackNotificationSelectionOptionsShape
  }

  state = {
    selectedSlug: null
  }

  render() {
    if (this.state.selectedSlug) {
      return <GoTo pathKey={ this.state.selectedSlug } />
    } else {
      return this.renderSelectionOptions();
    }
  }

  renderSelectionOptions() {
    const selectionOptions = this.props.tackNotificationSelectionOptions.get('selectionOptions').map((selectionOption, i) => {
      return (
        <li key={ i } className='list-group-item list-group-item-action tack-selection-option'>
          <a href='#' data-behavior='option-selector' onClick={ e => { e.preventDefault(); this.onPickOption(selectionOption.get('slug')) } }>
            <ul>
              { this.renderSelectionDefinitions(selectionOption) }
            </ul>
          </a>
        </li>
      )
    });
    return (
      <ul className='list-group'>{ selectionOptions }</ul>
    )
  }

  renderSelectionDefinitions(selectionOption) {
    const selectionOptionDefinitions = selectionOption.get('definitions').map((definition, i) => {
      return (
        <li key={ `selection-option ${ i }` }>
          { definition }
        </li>
      )
    });
    return selectionOptionDefinitions;
  }

  renderWaiting() {
    return(<Waiting />);
  }

  onPickOption(selectedSlug) {
    this.setState({ selectedSlug: selectedSlug });
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_notification_selection_options.jsx